export const DEVICE_TYPES = {
  SMARTPHONE: 'SMARTPHONE',
  PHABLET: 'PHABLET', // >= 375px
  TABLET: 'TABLET', // >= 544px
  LAPTOP: 'LAPTOP', // >= 768px
  DESKTOP: 'DESKTOP' // >= 1024px
}

export const SECURITY_ICONS_ID = 'shop-header-security-icons-box'
export const SHIPPING_FEE_TEXT_ID = 'shop-header-shipping-fee-text'
export const CART_SERVICE_ID = 'header-cart-service-fragment'
